import type { AxiosInstance } from 'axios';
import type { U3400TileLogicalUnitCode } from './U3400Service';

export interface U3400TileSeriesPoint {
  month: string;
  [metric: string]: string | number;
}

export interface U3400TileSeriesResult {
  mode: 'tile' | 'standalone';
  months: number;
  anchorMonth: string;
  series: U3400TileSeriesPoint[];
}

export function doFetchTileSeries(
  axios: AxiosInstance,
  code: U3400TileLogicalUnitCode,
  months: number,
) {
  return axios.get(`${code}/series`, {
    params: {
      mode: 'tile',
      months,
    },
  });
}
